
import "./styles.scss"

const LoaderInline = ({ style = {} }) => {
    return <div className="shared-loader-inline-container row" style={style}>
        <div className="lds-facebook"><div></div><div></div><div></div></div>
    </div>
}

export default LoaderInline